import AssistantHeaderTitle from './AssistantHeaderTitle';
import './AssistantHeader.less';
import AssistantHeaderButtons from './AssistantHeaderButtons';
import AssistantHeaderSearchInput from './AssistantHeaderSearchInput';

const AssistantHeader = () => {
    return (
        <div className={`bri-AssistantHeader`}>
            <div className={`bri-AssistantHeader-left`}>
                <AssistantHeaderTitle />
            </div>
            <div className={`bri-AssistantHeader-center`}>
                <AssistantHeaderSearchInput />
            </div>
            <div className={`bri-AssistantHeader-right`}>
                <AssistantHeaderButtons />
            </div>
        </div>
    );
};

export default AssistantHeader;
